import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderSummary = ({ selectedProfile, orderDetails }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const profileDetails = {
    'it-support': {
      name: 'IT Support Engineer',
      description: 'Complete training program with placement assistance',
      baseFee: 4999,
      icon: 'Monitor'
    },
    'fullstack-developer': {
      name: 'Full Stack Web Developer',
      description: 'Comprehensive Full Stack Development training with job guarantee',
      baseFee: 6999,
      icon: 'Code'
    },
    'data-analytics': {
      name: 'Data Analyst',
      description: 'Comprehensive Data Analytics training with job guarantee',
      baseFee: 5999,
      icon: 'Code'
    },
    'mobile-app-developer': {
      name: 'Mobile App Developer',
      description: 'Comprehensive Mobile App Development training with job guarantee',
      baseFee: 7499,
      icon: 'Code'
    },
    'devops': {
      name: 'DevOps Engineer',
      description: 'Comprehensive Cloud & Devops training with job guarantee',
      baseFee: 7999,
      icon: 'Code'
    },
    'artificial-intelligence': {
      name: 'AI Engineer',
      description: 'Artificial Intelligence & Machine Learning Training',
      baseFee: 9999,
      icon: 'Code'
    }
  };

  const profile = profileDetails[selectedProfile] || profileDetails['it-support'];
  const gst = Math.round(profile.baseFee * 0.18);
  const totalAmount = profile.baseFee + gst;

  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-subtle">
      <h2 className="text-lg font-semibold text-foreground mb-6 flex items-center">
        <Icon name="Receipt" size={20} className="mr-2" />
        Order Summary
      </h2>

      {/* Selected Profile */}
      <div className="border border-border rounded-lg p-4 mb-6">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={profile.icon} size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h3 className="font-medium text-foreground">{profile.name}</h3>
            <p className="text-sm text-text-secondary mt-1">{profile.description}</p>
            <div className="flex items-center mt-2">
              <Icon name="Clock" size={14} className="mr-1 text-text-secondary" />
              <span className="text-xs text-text-secondary">6-month program</span>
            </div>
          </div>
        </div>
      </div>

      {/* Fee Breakdown */}
      <div className="space-y-3 mb-6">
        <div className="flex justify-between items-center">
          <span className="text-foreground">Training Fee</span>
          <span className="font-medium text-foreground">{formatCurrency(profile.baseFee)}</span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-text-secondary text-sm">GST (18%)</span>
          <span className="text-text-secondary text-sm">{formatCurrency(gst)}</span>
        </div>
        
        <div className="border-t border-border pt-3">
          <div className="flex justify-between items-center">
            <span className="text-lg font-semibold text-foreground">Total Amount</span>
            <span className="text-xl font-bold text-primary">{formatCurrency(totalAmount)}</span>
          </div>
        </div>
      </div>

      {/* What's Included */}
      <div className="bg-muted rounded-lg p-4">
        <h4 className="font-medium text-foreground mb-3 flex items-center">
          <Icon name="CheckCircle" size={16} className="mr-2 text-success" />
          What's Included
        </h4>
        <ul className="space-y-2">
          <li className="flex items-center text-sm text-foreground">
            <Icon name="Check" size={14} className="mr-2 text-success flex-shrink-0" />
            Complete training curriculum
          </li>
          <li className="flex items-center text-sm text-foreground">
            <Icon name="Check" size={14} className="mr-2 text-success flex-shrink-0" />
            Placement assistance
          </li>
          <li className="flex items-center text-sm text-foreground">
            <Icon name="Check" size={14} className="mr-2 text-success flex-shrink-0" />
            Industry certification
          </li>
          <li className="flex items-center text-sm text-foreground">
            <Icon name="Check" size={14} className="mr-2 text-success flex-shrink-0" />
            24/7 support access
          </li>
        </ul>
      </div>

      {/* Money Back Guarantee */}
      <div className="mt-4 p-3 bg-success/10 border border-success/20 rounded-lg">
        <div className="flex items-center">
          <Icon name="Shield" size={16} className="mr-2 text-success" />
          <span className="text-sm font-medium text-success">100% Money Back Guarantee</span>
        </div>
        <p className="text-xs text-success/80 mt-1">
          If not satisfied within 30 days, get full refund
        </p>
      </div>
    </div>
  );
};

export default OrderSummary;